import { TimerObserver } from '../../../libs/timerObserver';
import { timerKeys } from '../../../shared/constants';
import { getLogger } from '../../../libs/logger';

export enum CallInitStep {
  NavigationStarted = 'navigationStarted',
  NavigationFinished = 'navigationFinished',

  SessionConnected = 'sessionConnected',

  CallInProgress = 'callInProgress',

  CallFailed = 'callFailed',
}

/**
 * Concurrent steps within call init.
 */
export enum MediaSetupStep {
  Start = 'start',
  MediaStarted = 'mediaStarted',
  AccessRequested = 'accessRequested',
  AccessFulfilled = 'accessFulfilled',
}

/**
 * Concurrent steps within call init.
 */
export enum SessionSetupStep {
  Start = 'start',
  RealtimeConnected = 'realtimeConnected',

  /**
   * Redux-store JS bundle is async imported.
   */
  ReduxStoreImported = 'reduxStoreImported',

  /**
   * Using api-core, a new WebRTC session is created
   * and token returned for the Provider to connect.
   */
  SessionCreated = 'sessionCreated',

  /**
   * Using api-core, a token is returned
   * for the Patient to connect to existing WebRTC session.
   */
  SessionJoined = 'sessionJoined',

  /**
   * Session is joined using vendor SDK.
   */
  SessionStarted = 'sessionStarted',

  SessionConnected = 'sessionConnected',
}

/**
 * The main timer for starting a call.
 */
export const callInitTimer = new TimerObserver<CallInitStep>(
  timerKeys.callInit,
  getLogger('callInitTimer'),
);

/**
 * A concurrent task within call-init.
 */
export const mediaSetupTimer = new TimerObserver<MediaSetupStep>(
  timerKeys.mediaSetup,
  getLogger('mediaSetupTimer'),
);

/**
 * A concurrent task within call-init.
 */
export const sessionSetupTimer = new TimerObserver<SessionSetupStep>(
  timerKeys.sessionSetup,
  getLogger('sessionSetupTimer'),
);
